var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgPersonalCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1311,
    height: 984,
    viewBox: "0 0 1311 984",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 497.5V0H1309.5V497.5L661 983.5L1 497.5Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1310.5 0H0V495L647 750.5L1310.5 221V0Z",
    fill: "#04162A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 547V619L446 892L0 547Z",
    fill: "#6C6C6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.5 602V547L977 794.5L1309.5 602Z",
    fill: "#04162A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPersonalCard);
export default __webpack_public_path__ + "static/media/bg-personal-card.be45cd61b9edc3e43b17e5cc6f1a31f2.svg";
export { ForwardRef as ReactComponent };